import React from "react";

import "./FormBox.scss";
import borderImage from "../../images/spectrum-form-top-border.png";

export default function FormBox({ children }) {
  return (
    <div className="FormBox">
      <img src={borderImage} className="border-image" alt={""} />
      {children}
    </div>
  );
}
